<template>
  <div class="d-flex overflow-auto justify-content-center flex-column align-items-center p-2">
    <div
      v-for="entry in entries"
      :key="entry.route"
      v-b-tooltip.hover
      :title="entry.name"
      class="admin-menu-entry shadow mb-3 d-flex align-items-center justify-content-center"
      :class="{ 'active-entry': entry.route === $route.name }"
      @click="onMenuEntrySelected(entry)"
    >
      <div class="d-flex justify-content-center flex-column align-items-center">
        <i :class="[entry.icon]" style="font-size: 2rem"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminMenuEntries',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      entries: [
        {
          name: this.$t('general.back_to_app'),
          route: this.$routeNames.DASHBOARD_PAGE_ROUTE,
          icon: 'el-icon-back',
        },
        {
          name: 'Dashboard',
          route: this.$routeNames.ADMIN_DASHBOARD_PAGE_ROUTE,
          icon: 'el-icon-s-grid',
        },
        {
          name: this.$t('general.user'),
          route: this.$routeNames.ADMIN_USER_PAGE_ROUTE,
          icon: 'el-icon-user',
        },
        {
          name: this.$t('general.user_requests'),
          route: this.$routeNames.ADMIN_USER_REQUESTS_PAGE_ROUTE,
          icon: 'el-icon-message-solid',
        },
        {
          name: this.$t('general.orders'),
          route: this.$routeNames.ADMIN_ORDER_PAGE_ROUTE,
          icon: 'el-icon-shopping-bag-2',
        },
        {
          name: this.$t('general.requests'),
          route: this.$routeNames.ADMIN_REQUEST_PAGE_ROUTE,
          icon: 'el-icon-receiving',
        },
        {
          name: 'Mixer Anfragen',
          route: this.$routeNames.ADMIN_MIXER_REQUEST_PAGE_ROUTE,
          icon: 'el-icon-set-up',
        },
        {
          name: this.$t('general.general_config'),
          route: this.$routeNames.ADMIN_GENERAL_CONFIG_PAGE_ROUTE,
          icon: 'el-icon-setting',
        },
      ],
    };
  },
  computed: {},
  methods: {
    onMenuEntrySelected(entry) {
      if (this.$route.name !== entry.route) this.$router.push({ name: entry.route });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
.admin-menu-entry {
  text-align: center;
  color: $primary;
  width: 80px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 0.75rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  border: 1px solid rgba($primary, 0.3);
  border-radius: 100%;

  &:hover {
    transform: translateY(-5px);
  }
}
.active-entry {
  font-weight: bold;
  i {
    color: $primary;
  }
}
</style>
